__turbopack_context__.v({
  "image": "Avatar-module-scss-module__2IbJlW__image",
  "indicator": "Avatar-module-scss-module__2IbJlW__indicator",
  "l": "Avatar-module-scss-module__2IbJlW__l",
  "m": "Avatar-module-scss-module__2IbJlW__m",
  "position": "Avatar-module-scss-module__2IbJlW__position",
  "s": "Avatar-module-scss-module__2IbJlW__s",
  "value": "Avatar-module-scss-module__2IbJlW__value",
  "xl": "Avatar-module-scss-module__2IbJlW__xl",
  "xs": "Avatar-module-scss-module__2IbJlW__xs",
});
